<template>
  <v-container>
    <v-layout row class="text-xs-center">
        <v-container style="position: relative;top: 13%;" class="text-xs-center">
              <h1 id="remove">Requests Initiated</h1>
              
              <pre><h1 id="ifExists">The following have requested for an immunity passport</h1></pre>
              <p id="ifNotSelected">Please select a name from the drop down menu</p>
              <p id="fail">Could not process the details</p>
              <h1 id="noRequests">You have no requests for now.</h1>
              <pre><p id="green">The request has been validated</p></pre>
              <v-btn color="primary"  id="request" @click="viewRequests()" primary>View</v-btn>
                
              <form id="form" name="requestsForm">
                <select id="border">
                  <option value="none">Choose the patient</option>
                </select>
                <pre><v-btn color="primary"  id="ifTrue" @click="getName()">Enter Government ID</v-btn></pre>
                <h1 id="ifValid">Validating request for {{name}}</h1>
              </form>
            <div id="display">
              <v-form>
              <v-text-field
                v-model="govtId"
                name="ID"
                label="Government ID"
              ></v-text-field>
              <v-btn color="primary"  id="click" @click="handleLogin()" primary >Validate</v-btn>
              </v-form>
            </div>
        </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import EosService from '@/eosio/EosService';
import Validate from './validateImmPass';

export default {
  data() {
    return {
      name: '',
      
      govtId: '',
      listRequests:[],
      eosio: null
    };
  },
  components:{
      Validate
  },
  methods: {
        handleLogin: async function() {
        document.querySelector("#green").style.display="none";
        document.querySelector("#fail").style.display="none";
        if (this.eosio === null) {
          this.eosio = new EosService(
            process.env.VUE_APP_IMMPASS_NAME,
            process.env.VUE_APP_IMMPASS_CONTRACT_NAME
          );
          console.log(process.env.VUE_APP_IMMPASS_CONTRACT_NAME);
          console.log(process.env.VUE_APP_IMMPASS_NAME);
        }

        if (!(await this.eosio.connect()))
          return console.log('Failed to get Scatter account');

        try{
          if (
            await this.eosio.transaction('validate', { _requester_name: this.name, _health_worker_name: this.eosio.account.name, _govt_id_number: this.govtId })
          ) {
            this.$router.push('pending');
            this.$store.commit('loginStatus', true);
            document.querySelector("#ifValid").style.display="none";
            document.querySelector("#click").style.display="none";
            document.querySelector("#display").style.display="none";
            document.querySelector("#ifTrue").style.display="none";
            document.querySelector("#border").style.display="none";
            document.querySelector("#green").style.display="inline";
            document.querySelector("#green").style.display="inline";
            document.querySelector("#ifExists").style.display="none";
            document.querySelector("#remove").style.display="inline";
          }
        }catch(error){
          document.querySelector("#fail").style.display="inline";
          document.querySelector("#display").style.display="none";
          document.querySelector("#ifValid").style.display="none";
          console.log(error);
        }

      },
      getName: async function(){
        document.querySelector('#ifNotSelected').style.display="none";
        document.querySelector('#display').style.display="none";
        document.querySelector('#ifValid').style.display="none";
        var value=document.querySelector("#border").value;
        this.name=value;
        
        if(this.name!=='none') {
          document.querySelector('#display').style.display="inline";
          document.querySelector('#ifValid').style.display="inline";
        }
        else{
          document.querySelector('#ifNotSelected').style.display="inline";
        }
        
      },
      viewRequests: async function() {
      if (this.eosio === null) {
        this.eosio = new EosService(
          process.env.VUE_APP_IMMPASS_NAME,
          process.env.VUE_APP_IMMPASS_CONTRACT_NAME
        );
      }
        
      if (!(await this.eosio.connect()))
        return console.log('Failed to get Scatter account');
        
      try{
        let requests=await this.eosio.getRequests();
        let array=[];
        var count=0;
        for(var index in requests){
            
            if(requests[index].healthworker_name == this.eosio.account.name) {
                array.push(requests[index]);
                count++;
                var option=document.createElement('option');
                option.value=requests[index].requester_name;
                option.text=requests[index].requester_name;

                var linebreak=document.createElement("br");
                document.querySelector("#border").appendChild(linebreak);
                document.querySelector("#border").appendChild(option);
                document.querySelector("#border").appendChild(linebreak);
                
            }
        
        }
        this.listRequests=array;
        document.querySelector('#remove').style.display="none";
        document.querySelector('#request').style.display="none";
        document.querySelector('#ifValid').style.display="none";  
        if(count!=0) {
            document.querySelector('#ifExists').style.display="inline";
            
            document.querySelector('#border').style.display="block";
            document.querySelector('#ifTrue').style.display="inline";
        }
        else document.querySelector('#noRequests').style.display="inline";
      }catch(error){
        console.log(error);
      }
    }
  }
};
</script>

<style scoped>
    #remove{
        display:block;
    }
    #request{
        display:inline;
    }
    #ifExists{
        display:none;
    }
    #display{
        display:none;
    }
    #noRequests{
        display:none;
    }
    #border{
        display:none;
        margin:auto;
        padding: 10px;
        border: 2px solid black;
    }
    #ifTrue{
      display:none;
    }
    #ifValid{
      display:none;
      color:green;
    }
    #fail{
      color:red;
      display:none;
    }
    #green{
      color:green;
      display:none;
    }
    #ifNotSelected{
      color:red;
      display:none;
    }
</style>